const getData = ({config}) => {
    return {
        currency: config?.context.currency,
    };
};

module.exports = getData;
